import z from 'zod'

export const YearlyFeeRowSchema = z.object({
  year: z.number().int().describe('Jahr'),
  profitShareCustomer: z.number().min(0).max(100).optional().describe('Profit-Share Kunde [%]'),
  floorEurPerMw: z.number().max(350_000).optional().describe('Floor [EUR/MW]'),
  cpaFixPriceEurPerMw: z.number().max(350_000).optional().describe('CPA Fixpreis [EUR/MW]'),
})

export const YearlyFeeListSchema = z.array(YearlyFeeRowSchema).max(10)

export const FeeDataFormSchema = z
  .object({
    compensationModel: z.enum(['CPA', 'Profit-Share only', 'Profit Share mit Floor']).describe('Vergütungsmodell'),
    serviceFeeEurPerYear: z.number().describe('Fixkostenpauschale in EUR pro Jahr'),
    oneOffConfigurationFeeEur: z.number().describe('Einmalige Konfigurationsgebühr [EUR]'),
    maxUsableCyclesPerYear: z.number().describe('Max. nutzbare Zyklen pro Jahr'),
    maxUsableCyclesPerDay: z.number().describe('Max. nutzbare Zyklen pro Tag'),
    costPerAdditionalCycleEurPerMwPerCyc: z.number().optional().describe('Kosten je Mehrzyklus [EUR/MW/Zyklus]'),
    depthOfDischargePercent: z.number().min(0).max(100).optional().describe('Entladungstiefe [%]'),
    continuousGridConnectionPowerMw: z.number().describe('Dauerhaft nutzbare Netzanschlussleistung [MW]'),
    guaranteedMinimumAvailabilityPercent: z.number().min(0).max(100).describe('Garantierte Mindestverfügbarkeit [%]'),
    thresholdActualDeviationNonavailability: z
      .number()
      .optional()
      .describe('Schwellenwert Ist-Abweichung Nichtverfügbarkeit'),
    profitShareIntervalStepsAvailabilityPercent: z
      .number()
      .min(0)
      .max(100)
      .optional()
      .describe('Profit-Share Intervallstufen Verfügbarkeit [%]'),
    profitShareIntervalStepsReductionPercent: z
      .number()
      .min(0)
      .max(100)
      .optional()
      .describe('Profit-Share Intervallstufen Reduktion [%]'),
    redispatchV2BalancingModel: z.string().optional().describe('RD 2.0 Bilanzierungsmodell'),
    billingModeRedispatchV2: z.string().optional().describe('RD 2.0 Abrechnungsmodus'),
    redispatchV2CallModel: z.string().optional().describe('RD 2.0 Abrufmodell'),
  })
  .describe('Konditionen')

export const FeeDataSchema = FeeDataFormSchema.extend({
  yearlyFee: YearlyFeeListSchema.optional().describe('Jährliche Konditionen'),
}).describe('Konditionen')

export const FeeDataSchemaForSharepoint = FeeDataFormSchema.extend({
  contractNumber: z.string().min(1),
  feeValidFrom: z.coerce.date(),
  feeValidUntil: z.coerce.date(),
})
